import { DatePipe } from '@angular/common';
import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Constant } from 'src/Constant';
import { GlobalServiceService } from '../Services/GlobalService/global-service.service';
import { map } from 'rxjs/operators';
import { Http } from '@angular/http';

@Component({
  selector: 'app-genericlink',
  templateUrl: './genericlink.component.html',
  styleUrls: ['./genericlink.component.css']
})


export class GenericlinkComponent implements OnInit {
  selectedPaymentOption: string = 'debitNetbankingeMandate';
  showCCSINRI = false;
  nriFLAG: any;
  showCCSIPan = true;
  isChecked: boolean = false;
  @ViewChild('collapseThree') collapseThree!: ElementRef;


  @ViewChild('myDiv') myDiv!: ElementRef;
  @ViewChild('ccsiform') ccsiform!: ElementRef;
  @ViewChild('enachform') enachform!: ElementRef;
  @ViewChild('upiform') upiform!: ElementRef;
  public isstatus:any;
  public userdata: any;
  modalRef!: BsModalRef;
  emandate: any;
  upiUrl: any;
  ccsi: any;
  enach: any;
  ccsiReturnUrl: any;
  template: any
  flag: any;
  policyno: any;
  renPayMode: any;
  isInHouseApplNo: boolean = false;
  blockAcDtls: boolean = true;

  //activate international ccsi start 
  ccsiPayglocal: any;
  datePipe: DatePipe = new DatePipe('en-US');
  showCCSI = true;
  //activate international ccsi end
  enableForNACHVendor: any = "PAYGLOCAL";
  enableForCCSIVendor: any = "PAYGLOCAL";
  enableForUPIVendor: any = "PAYGLOCAL";

  isSystem :any ="O";
  routingInfoList: any = [];

  showAccodian3 :boolean=false;


  dualMandateFlag: any ='N';
  dualMandateType: any ='PRIMARY';

  mandateCal :any;
 callbackURL: any;
  constructor(private localStorageService: LocalStorageService,
    private router: Router,
    private modalService: BsModalService,
    private toster: ToastrService,
    private spinner: NgxSpinnerService,
    private service: GlobalServiceService,
    private ngZone: NgZone,
    private http:Http) { }

    ngOnInit() {
      this.manadateAuthToken();
     
      // this.loadJs();
       this.policyno = this.localStorageService.get('p_policy_no_auto');
       console.log(this.policyno);
       this.renPayMode = this.localStorageService.get('ren_pay_mode');

       this.dualMandateFlag = this.localStorageService.get('dualMandateFlag');
       this.dualMandateType = this.localStorageService.get('dualMandateType');
       this.callbackURL = this.localStorageService.get('callbackURL');

       this.checkSystem(this.policyno);

       setTimeout(() => {
       // this.flag = sessionStorage.getItem('flag');
       if(this.isSystem == 'N'){
        this.emandate = Constant.BaseUrl + Constant.emandate_NGIN;
        this.enach = Constant.BaseUrl + Constant.enach_NGIN;
        this.upiUrl = Constant.BaseUrl + Constant.upiMandate_NGIN;
       }else{
        this.emandate = Constant.BaseUrl + Constant.emandate;
        this.ccsi = Constant.ccsi;
        this.enach = Constant.BaseUrl + Constant.enach;
        this.upiUrl = Constant.BaseUrl + Constant.upiMandate
       }

       this.checkForVendor();
       this.checkForUPIVendor();
       this.checkForCCSIVendor();
   
      if(this.isSystem == 'o' || this.isSystem == 'O' ){
       if (this.renPayMode && this.renPayMode == 'UPI_M' || this.renPayMode == 'upi_m' || this.renPayMode == 'NACH' || this.renPayMode == 'nach' || this.renPayMode == 'CCSI' || this.renPayMode == 'ccsi') {
         this.updateRenPayMode(this.renPayMode);
       } else {
         this.getAllData(this.template);
       }
      }else{
        this.getAllData(this.template);
      }
        }, 1500); // Wait for 2 seconds
     }
    newAgentCode: any
    mandateTokenValue: any;
    manadateAuthToken() {
      const authCred = Constant.authCred;
      let url = Constant.mandateAuthToken;
      this.service.PostService(url, authCred).subscribe((response: any) => {
        console.log(response);
        this.mandateTokenValue = response.token
      }, (error) => {
        console.log(error);
      });
    }
    channel: any
    subChannel: any
    channelDetails(code: any, token: any) {
      let url = Constant.channelDetails(code);
      this.service.getService(url, token).subscribe((response: any) => {
        this.channel = response.channel
        this.subChannel = response.subChannel
      }, (error) => {
        console.log(error);
      });
    }

     checkSystem(applicationNo :any){
      this.spinner.show();
      let urlCheckPolicy = Constant.BaseUrl + Constant.checkPolicy;
      let reqObj1 = {
        "appln_number": applicationNo,
      }
      this.service.PostService(urlCheckPolicy, reqObj1).subscribe((response: any) => {
        console.log(response);
        if (response.statusCode == '200') {
          this.routingInfoList = response.routingInfoList[0];
          this.isSystem = this.routingInfoList.target_system;
        }
      })
     }

     checkForVendor() {
      //RAZORPAY,
      //TECHPROCESS, basis on that values it will enable and desabled 
      //this.enableForVendor = "TECHPROCESS";
      let url = Constant.vendorTypeNACH
      this.http.get(url).pipe(map((res: any) => res.json())).subscribe(res => {
        if (res) {
          //this.enableForVendor = res.char_VALUE;
          this.enableForNACHVendor = res[0].char_VALUE;
          // this.enableForVendor = "TECHPROCESS";
          // this.enableForVendor = "RAZORPAY";
        }
     //     this.enableForNACHVendor = "PAYGLOCAL";
      })
      if(this.isSystem == 'N' || this.isSystem == 'n'){
        this.enableForNACHVendor = "TECHPROCESS";
      }
    }
   
   
     checkForUPIVendor() {
      //RAZORPAY,
      //TECHPROCESS, 
      //this.enableForUPIVendor = "TECHPROCESS";
      let url = Constant.vendorTypeUPI
      this.http.get(url).pipe(map((res: any) => res.json())).subscribe(res => {
        if (res) {
          this.enableForUPIVendor = res[0].char_VALUE;
          // this.enableForVendor = "TECHPROCESS";
          // this.enableForUPIVendor = "RAZORPAY";
        }
      //  this.enableForUPIVendor = "PAYGLOCAL";
      })
      if(this.isSystem == 'N' || this.isSystem == 'n'){
        this.enableForUPIVendor = "TECHPROCESS";
      }
    }
  
    checkForCCSIVendor() {
      //RAZORPAY,
      //TECHPROCESS, 
      //this.enableForUPIVendor = "TECHPROCESS";
      let url = Constant.vendorTypeCCSI
      this.http.get(url).pipe(map((res: any) => res.json())).subscribe(res => {
        if (res) {
          this.enableForCCSIVendor = res[0].char_VALUE;
          // this.enableForVendor = "TECHPROCESS";
          // this.enableForUPIVendor = "RAZORPAY";
        }
       // this.enableForCCSIVendor = "PAYGLOCAL";
      })
      if(this.isSystem == 'N' || this.isSystem == 'n'){
        this.enableForCCSIVendor = "HDFCCCSI";
      }
    }
   
     //update pay mode 
     updateRenPayMode(renPayMode: any) {
       let url = Constant.renPayModeChange;
       let reqObj =
       {
         appln_no: this.policyno,
         ren_pay_mode: renPayMode
       }
       this.service.PostService(url, reqObj).subscribe((response:any) => {
         console.log(response);
         if (response.errorcode == 'success') {
           // this.toster.success(response.message);
           this.getAllData(this.template);
         } else {
           this.toster.error(response.message);
         }
       })
     }

     setLogs(consumerID :any){
      let url = Constant.storeLogs;
      let reqObj =
      {
        module: "AUTOMANDATE_REG",
        consumer_id: consumerID
      }
      this.service.PostService(url, reqObj).subscribe((response: any) => {
        console.log("LOG Response :: " + response.status)
      })
  
    }
  
   
//      getAllData(template:any) {
//        let url = Constant.BaseUrl + Constant.getdataGenericLink;
//        let reqObj =
//        {
//          p_application_no: this.policyno,
//          p_application: "WEB"
//        }
   
//        this.spinner.show();
//        this.service.PostService(url, reqObj).subscribe((response:any) => {
//          let data = [];
//          if (response.p_error_code === 'SUCCESS') {
//            data = response.p_user_dtls;
//            // console.log('here');
   
//            console.log(data);
//            // debugger
//            // return;
//            if (data) {
//              this.userdata = response.p_user_dtls;
//              // setCCSIData()  // CCSI for Existing Customer
   
//              let [day, month, year] = this.userdata.stringval6.split(/[-\/]/);
//              let [day2, month2, year2] = this.userdata.stringval7.split(/[-\/]/);
   
//              if (day === '29' && month === '02') {
//                day = '28';
//                this.userdata.stringval6 = `${day}-${month}-${year}`
//              }
//              if (day2 === '29' && month2 === '02') {
//                day2 = '28';
//                this.userdata.stringval7 = `${day2}-${month2}-${year2}`
//              }
   
   
//              if (this.userdata.stringval13 != "") {
//                this.policyno = this.userdata.stringval13
//              }
   
//              if (this.userdata.stringval14 != "") {
//                this.userdata.stringval14 == '3000000007' ? this.isInHouseApplNo = true : this.isInHouseApplNo = false
//              }
//              if (this.userdata.stringval15 != "") {
//                if (this.userdata.stringval15 == 'IPPBBC' || this.userdata.stringval15 == 'IPPB' || this.userdata.stringval15 == 'IPPBC' || this.userdata.stringval15 == 'INSTAB' || this.userdata.stringval15 == 'DIGIBANCA') {
//                  this.blockAcDtls = false
//                } else {
//                  this.blockAcDtls = true
//                }
//              }
//              debugger;
//              // check agent code for inhouse buyjourney
//              if (this.userdata.stringval5 == 'CCSI' && this.userdata.stringval16 != 'NRI') {
//                // alert("CCSI facility is not available. Request to you please select another renewal preferred mode.");
//                if (this.userdata.stringval2 > 15000 && this.userdata.stringval15 != 'GBOWEB') {
//                  alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.");
//                  const newWindow = window.open('', '_self');
//                  if (newWindow) {
//                    newWindow.close();
//                  }
//                } else {
//                  this.setCCSIData();
//                }
//              }
   
//              else if (this.userdata.stringval5 == 'CCSI' && this.userdata.stringval16 == 'NRI') {
//               this.showAccodian3=true;
//                this.showCCSINRI = true;

//                if (this.userdata.stringval2 > 15000 && this.userdata.stringval15 != 'GBOWEB') {
//                  this.showCCSIPan = false;
//                } else {
//                  this.showCCSIPan = true;
//                }
//               this.collapseThree.nativeElement.classList.add('show');
//              }

//              else if (this.userdata.stringval5 == 'EMAND' || this.userdata.stringval5 == 'emand') {
//                this.setEmandateData();
//              } else if (this.userdata.stringval5 == 'NACH' || this.userdata.stringval5 == 'nach') {
//                let totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
//                if (totalAmount > 10000000) {
//                  alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.");
//                  const newWindow = window.open('', '_self');
//               if (newWindow) {
//                 newWindow.close();
//               }
//                } else {
//                  this.setEnachData();
//                }
//              }
             
//              else if (this.userdata.stringval5 == 'UPI_M' || this.userdata.stringval5 == 'upi_m') {
   
//                // if ((this.userdata.stringval2 * 1.1) > 15000) {
//                //   alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.");
//                //   window.open('', '_self').close();
//                // } else {
//                //   if(this.userdata.stringval17 =='PSF'){
//                //     this.sendUPIDataNewCust();
//                //   }else{
//                //     alert("UPI facility is not available.");
//                //   }
//                // }
   
//                // //AG-2773 Start
//                // let url = Constant.validateUPIAgent;
//                // let reqObj =
//                // {
//                //   agentCode: this.userdata.stringval14,
//                //   sysType: "UPI_CONFIG"
//                // }
//                // this.spinner.show();
//                // this.service.PostService(url, reqObj).subscribe(response => {
//                //   debugger
//                //   if (response.isAuthenticated === 'Y') {
//                //     if ((this.userdata.stringval2 * 1.1) > 15000) {
//                //       alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.");
//                //       window.open('', '_self').close();
//                //     } else {
//                //       this.sendUPIDataNewCust();
//                //     }
//                //   } else {
//                //     if ((this.userdata.stringval2 * 1.1) > 15000) {
//                //       alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.");
//                //       window.open('', '_self').close();
//                //     } else {
//                //       if (this.userdata.stringval17 == 'PSF') {
//                //         this.sendUPIDataNewCust();
//                //       } else {
//                //         alert("UPI facility is not available.");
//                //       }
//                //     }
//                //   }
//                // })
   
//                if (this.userdata.stringval2 > 15000 ) {
//                  alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.");
//                  const newWindow = window.open('', '_self');
//                  if (newWindow) {
//                    newWindow.close();
//                  }
//                } else {
//                 this.proceedwithUpi();
//                 }
   
   
//              }
//              else if (this.userdata.stringval5 == 'CA') {
//                alert("You have opted module 'CA'. you can't proceed further");
//                const newWindow = window.open('', '_self');
//               if (newWindow) {
//                 newWindow.close();
//               }
//              } else {
//                alert("You have opted wrong module. you can't proceed further");
//              }
//            }
//            else {
//              alert("No Data Found");
//              this.toster.error("No Data Found");
//            }
//          }
//          else {
//            alert(response.p_message);
//            const newWindow = window.open('', '_self');
//            if (newWindow) {
//              newWindow.close();
//            }
//          }
//          setTimeout(() => {
//            /** spinner ends after 3 seconds */
//            this.spinner.hide();
//          }, 3000);
   
   
//        })
//      }
   
   
//      proceedwithUpi(){
//        if(this.enableForUPIVendor=='TECHPROCESS'){
//          this.sendUPIDataNewCust();
//        }
   
//        if(this.enableForUPIVendor=='RAZORPAY'){
//          this.payWithRozarPayforUPI();
//        }
//      }

  onProceed(){

  }


//   setEnachData()   // ENACH FOR NEW CUSTOMER
//   {
//     var totalAmount;
//     if (this.userdata.stringval2) {
//       totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
//       // if (totalAmount > 1000000) {   // mandate value or calculated value
//       //       totalAmount = 1000000;  // calculated value i.e mandate value will be 10 lac
//       // } 
//     } else {
//       totalAmount = this.userdata.stringval2;
//     }

//     var policyHolderName = this.blockAcDtls ? this.userdata.stringval1 : "";
//     (<HTMLInputElement>document.getElementById("policyHolderNameenach")).value = policyHolderName;

//     (<HTMLInputElement>document.getElementById("totalAmountenach")).value = parseFloat(totalAmount).toFixed(2);

//     (<HTMLInputElement>document.getElementById("consumerIdenach")).value = this.policyno;

//     var consumerMobileNo = this.userdata.stringval3;
//     (<HTMLInputElement>document.getElementById("consumerMobileNoenach")).value = consumerMobileNo;

//     var consumerEmailId = this.userdata.stringval4;
//     (<HTMLInputElement>document.getElementById("consumerEmailIdenach")).value = consumerEmailId;

//     var debitStartDate = this.userdata.stringval6;
//     (<HTMLInputElement>document.getElementById("debitStartDateenach")).value = debitStartDate;

//     var debitEndDate = this.userdata.stringval7;
//     (<HTMLInputElement>document.getElementById("debitEndDateenach")).value = debitEndDate;

//     var maxAmount = '100';
//     (<HTMLInputElement>document.getElementById("maxAmountenach")).value = maxAmount;

//     var amountType = "M";
//     (<HTMLInputElement>document.getElementById("amountTypeenach")).value = amountType;

//     var frequency = "ADHO";
//     (<HTMLInputElement>document.getElementById("frequencyenach")).value = frequency;

//     var moduleName = "INSTAB|OPEN_LINK_NEW";
//     (<HTMLInputElement>document.getElementById("moduleNameenach")).value = moduleName;

//     var accountNo = this.blockAcDtls ? this.userdata.stringval9 : "";
//     (<HTMLInputElement>document.getElementById("accountNoe")).value = accountNo;

//     var ifscCode = this.blockAcDtls ? this.userdata.stringval11 : "";
//     (<HTMLInputElement>document.getElementById("ifscCodee")).value = ifscCode;

//     // console.log("totalAmount is",totalAmount)

//     setTimeout(() => {
//       this.enachform.nativeElement.click();
//     }, 1000);
//   }

//   setEmandateData() {   //Emandate for NEW Customer

//     // console.log("response.p_pymnt_list", this.userdata);

//     var policyHolderName = this.blockAcDtls ? this.userdata.stringval1 : "";
//     (<HTMLInputElement>document.getElementById("policyHolderNameexeman")).value = policyHolderName;

//     var totalAmount = '5';
//     (<HTMLInputElement>document.getElementById("totalAmountexeman")).value = totalAmount;

//     (<HTMLInputElement>document.getElementById("consumerIdexeman")).value = this.policyno;

//     var consumerMobileNo = this.userdata.stringval3;
//     (<HTMLInputElement>document.getElementById("consumerMobileNoexeman")).value = consumerMobileNo;

//     var consumerEmailId = this.userdata.stringval4;
//     (<HTMLInputElement>document.getElementById("consumerEmailIdexeman")).value = consumerEmailId;

//     var debitStartDate = this.userdata.stringval6;
//     (<HTMLInputElement>document.getElementById("debitStartDateexeman")).value = debitStartDate;

//     var debitEndDate = this.userdata.stringval7;
//     (<HTMLInputElement>document.getElementById("debitEndDateexeman")).value = debitEndDate;

//     var maxAmount:any;
//     maxAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
//     // var maxAmount = this.userdata.stringval8;
//     (<HTMLInputElement>document.getElementById("maxAmountexeman")).value = parseFloat(maxAmount).toFixed(2);

//     var amountType = "M";
//     (<HTMLInputElement>document.getElementById("amountTypeexeman")).value = amountType;

//     var frequency = "ADHO";
//     (<HTMLInputElement>document.getElementById("frequencyexeman")).value = frequency;

//     var renewalID = "";
//     (<HTMLInputElement>document.getElementById("renewalIDexeman")).value = renewalID;

//     var moduleName = "OPEN_LINK_NEW";
//     (<HTMLInputElement>document.getElementById("moduleIdexeman")).value = moduleName;

//     var payableAmount = '0';
//     (<HTMLInputElement>document.getElementById("payableAmountexeman")).value = payableAmount;

//     var accountNo = this.blockAcDtls ? this.userdata.stringval9 : "";
//     (<HTMLInputElement>document.getElementById("accountNo")).value = accountNo;

//     var ifscCode = this.blockAcDtls ? this.userdata.stringval11 : "";
//     (<HTMLInputElement>document.getElementById("ifscCode")).value = ifscCode;

//     setTimeout(() => {
//       this.myDiv.nativeElement.click();
//     }, 1000);
//   }


//   sendUPIDataNewCust() {    // UPI Mandate for new customer
//     //debugger

//     //console.log(this.userdata);
//     var maxAmount:any;
//     var calMaxAmt;
//     // if ((this.userdata.stringval2 <= 5000) && (this.userdata.stringval8 > 5000)) {   // calulated value
//     calMaxAmt = (this.userdata.stringval2 * 1.1);
//     maxAmount = calMaxAmt.toFixed(2)
//     if (maxAmount > 15000) {
//       alert("Mandate amount exceeds maximum amount limit.");
//       return;
//     } else {
//       maxAmount = maxAmount;
//       var policyHolderName = this.blockAcDtls ? this.userdata.stringval1 : "";
//       (<HTMLInputElement>document.getElementById("policyHolderNameu")).value = policyHolderName;

//       var totalAmount = '0';
//       (<HTMLInputElement>document.getElementById("totalAmountu")).value = totalAmount;

//       var consumerId = this.policyno;
//       (<HTMLInputElement>document.getElementById("consumerIdu")).value = consumerId;

//       var consumerMobileNo = this.userdata.stringval3;
//       (<HTMLInputElement>document.getElementById("consumerMobileNou")).value = consumerMobileNo;

//       var consumerEmailId = this.userdata.stringval4;
//       (<HTMLInputElement>document.getElementById("consumerEmailIdu")).value = consumerEmailId;

//       var debitStartDate = this.userdata.stringval6;
//       (<HTMLInputElement>document.getElementById("debitStartDateu")).value = debitStartDate;

//       var debitEndDate = this.userdata.stringval7;
//       (<HTMLInputElement>document.getElementById("debitEndDateu")).value = debitEndDate;

//       // var maxAmount = this.userdata.stringval8;
//       (<HTMLInputElement>document.getElementById("maxAmountu")).value = maxAmount;

//       var amountType = "M";
//       (<HTMLInputElement>document.getElementById("amountTypeu")).value = 'M'

//       var frequency = "ADHO";
//       (<HTMLInputElement>document.getElementById("frequencyu")).value = frequency;

//       var renewalID = "OPEN_LINK_NEW";
//       (<HTMLInputElement>document.getElementById("renewalIDu")).value = renewalID;

//       var payableAmount = '0';
//       (<HTMLInputElement>document.getElementById("payableAmountu")).value = payableAmount;

//       var accountNo = this.blockAcDtls ? this.userdata.stringval9 : "";
//       (<HTMLInputElement>document.getElementById("accountNo")).value = accountNo;

//       var ifscCode = this.blockAcDtls ? this.userdata.stringval11 : "";
//       (<HTMLInputElement>document.getElementById("ifscCode")).value = ifscCode;

//       setTimeout(() => {
//         this.upiform.nativeElement.click();
//       }, 1000);

//     }


//   }

//   setCCSIData()  // CCSI for Existing Customer
//   {

//     // console.log("user data existing ",this.userdata)
//     var policyHolderName = this.userdata.stringval1;
//     (<HTMLInputElement>document.getElementById("policyHolderccsiexi")).value = policyHolderName;

//     var totalAmount = this.userdata.stringval2;
//     (<HTMLInputElement>document.getElementById("totalAmountccsiexi")).value = parseFloat(totalAmount).toFixed(0);

//     (<HTMLInputElement>document.getElementById("consumerIdccsiexi")).value = this.policyno;

//     var consumerMobileNo = this.userdata.stringval3;
//     (<HTMLInputElement>document.getElementById("consumerMobileNoccsiexi")).value = consumerMobileNo;

//     var consumerEmailId = this.userdata.stringval4;
//     (<HTMLInputElement>document.getElementById("consumerEmailIdccsiexi")).value = consumerEmailId;

//     var debitStartDate = this.userdata.stringval6;
//     (<HTMLInputElement>document.getElementById("debitStartDateccsiexi")).value = debitStartDate;

//     var debitEndDate = this.userdata.stringval7;
//     (<HTMLInputElement>document.getElementById("debitEndDateccsiexi")).value = debitEndDate;

//     (<HTMLInputElement>document.getElementById("return_urlccsiexi")).value = this.ccsiReturnUrl;

//     setTimeout(() => {
//       this.ccsiform.nativeElement.click();
//     }, 1000);
//   }


//   //implemet international ccsi start

//   openCCSINRI() {
//     this.spinner.show();
//     let generateURL = Constant.NRIccsi;
//     var options

//     const date1 = this.userdata.stringval6;
//     const prt = moment(date1, 'DD-MM-YYYY').toDate();;
//     const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
//     const date2 = this.userdata.stringval7;
//     const prt1 = moment(date2, 'DD-MM-YYYY').toDate();;
//     const formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');


//     options = {
//       "merchantTxnId": this.policyno,
//       "allowedPaymentMethods": [
//         {
//           "paymentMethod": "CARD"
//         }
//       ],
//       "paymentData": {
//         "totalAmount": 1,
//         "txnCurrency": "INR"
//       },
//       "riskData": {
//         "customerData": {
//           "customerCategory": "FC"
//         }
//       },
//       "standingInstruction": {
//         "data": {
//           "maxAmount": parseFloat(this.userdata.stringval2).toFixed(),
//           "numberOfPayments": "N",
//           "frequency": "ONDEMAND",
//           "type": "VARIABLE",
//           "startDate": formattedDate1,
//           "endDate": formattedDate2,
//           "mode": "REGISTER"
//         }
//       },
//       "merchantCallbackURL": Constant.NRIccsiCallbackURL,
//       "moduleName": "OPEN_LINK_NEW",
//       "policyHolderName": this.userdata.stringval1
//     }





//     this.service.PostService(generateURL, options).subscribe((response: any) => {

//       if (response.status == 'INPROGRESS') {
//         this.ccsiPayglocal = response.data.redirectUrl;
//         window.open(this.ccsiPayglocal.toString(), '_blank');
//         this.spinner.hide();
//       } else {
//         this.toster.error("ERROR :: " + response.status);
//         this.spinner.hide();
//       }
//     })
//   }

//   openDomesticCCSI() {
//     this.setCCSIData();
//   }



//   //razorpay upi implementation starts
// payWithRozarPayforUPI() {
//   let data;
//   let merchantID = Constant.RAZORPAY_KEY;

//   var maxAmount;
//   var calMaxAmt:any;
//   calMaxAmt = (this.userdata.stringval2 * 1.1);
//   maxAmount =  parseFloat(calMaxAmt).toFixed(),
 
//     data = {
//       'policyHolderName': '',
//       'totalAmount': 0,
//       'merchantId': merchantID,
//       'consumerId': this.policyno,
//       'consumerMobileNo': this.userdata.stringval3,
//       'consumerEmailId': this.userdata.stringval4,
//       'debitStartDate': this.userdata.stringval6,
//       'debitEndDate': this.userdata.stringval7,
//       'maxAmount': maxAmount,
//       'amountType': 'M',
//       'frequency': 'ADHO',
//       'moduleName': "OPEN_LINK_NEW",
//     // 'moduleName': "OPEN_LINK_NEW",
//       'renewalID': "OPEN_LINK_NEW",
//       'payableAmount': 0,
//       'takeAccountNo': this.userdata.stringval9,
//       'takeIFSCCode': this.userdata.stringval11,
//       'prefDate': '',
//       'prefType': '',
//       'authType': '',
//       "paymode":"upi"
//     }
 

//   let url = Constant.createCustomerUPI;
//   let reqObj = data;
//   this.spinner.show();
// //console.log("Request1"+reqObj)

//   this.service.PostService(url, reqObj).subscribe((response: any) => {
//     console.log(response);
//     if (response && response.oid && response.custRes.id) {
//       this.spinner.hide();
//       this.callRozarPayforUPI(response.oid,response.custRes.id);
//     }
//     else {
//       this.spinner.hide();
//       alert(response.p_message);
//     }
//   })
// }

// callRozarPayforUPI(orderID: any,custID:any) {
//   let merchantID = Constant.RAZORPAY_KEY;
//   var options = {
//     "key": merchantID,
//     "order_id": orderID,
//     "customer_id": custID,
//     "recurring": "1",
//     "image": "./assets/img/bajaj-logo.png",
//     "handler": (response: any) => {
//       console.log(response);
//       if (response) {
//         localStorage.setItem("s2sResponse", JSON.stringify(response));
//         this.ngZone.run(() => this.router.navigate(['/RazorPayThankyou']))
//       }
//     },
//     "notes": {
//       "note_key 1": "",
//       "note_key 2": ""
//     },
//     "retry": {
//       "enabled": false
//     },
//     "hidden": {
//       "email": true,
//       "contact": true
//     },
//     "theme": {
//       "color": "#3977b7"
//     }
//   };
//   var rzp1 = new this.service.nativeWindow.Razorpay(options);
//   rzp1.open();
//   rzp1.on('payment.failed', (response: any) => {
//     localStorage.setItem("razorpayError", JSON.stringify(response));
//     this.ngZone.run(() => this.router.navigate(['/RazorPayFailure']))
//   });
// }


// //razorpay upi implementation ends
getAllData(template:any) {
  
  this.setLogs(this.policyno);

  let url = Constant.BaseUrl + Constant.getdataGenericLink;
  let reqObj =
  {
    p_application_no: this.policyno,
    p_application: "WEB"
  }

  this.spinner.show();
  this.service.PostService(url, reqObj).subscribe((response:any) => {
    let data = [];
    if (response.p_error_code === 'SUCCESS') {
      data = response.p_user_dtls;
     
      // console.log('here');

      console.log(data);
      // debugger
      // return;
      if (data) {
        this.userdata = response.p_user_dtls;
        this.newAgentCode = this.userdata.stringval14
        // this.channelDetails(this.newAgentCode,this.mandateTokenValue);
        // setCCSIData()  // CCSI for Existing Customer

        let [day, month, year] = this.userdata.stringval6.split(/[-\/]/);
        let [day2, month2, year2] = this.userdata.stringval7.split(/[-\/]/);

        if (day === '29' && month === '02') {
          day = '28';
          this.userdata.stringval6 = `${day}-${month}-${year}`
        }
        if (day2 === '29' && month2 === '02') {
          day2 = '28';
          this.userdata.stringval7 = `${day2}-${month2}-${year2}`
        }


        // if (this.userdata.stringval13 != "") {
        //   this.policyno = this.userdata.stringval13
        // }

        if (this.userdata.stringval14 != "") {
          this.userdata.stringval14 == '3000000007' ? this.isInHouseApplNo = true : this.isInHouseApplNo = false
        }
        if (this.userdata.stringval15 != "") {
          if (this.userdata.stringval15 == 'IPPBBC' || this.userdata.stringval15 == 'IPPB' || this.userdata.stringval15 == 'IPPBC' || this.userdata.stringval15 == 'INSTAB' || this.userdata.stringval15 == 'DIGIBANCA') {
            this.blockAcDtls = false
          } else {
            this.blockAcDtls = true
          }
        }

         // OPS-7166 starts
         if (this.userdata.stringval18 != "") {
          if (this.userdata.stringval18 == 'PSF_DEFENCE') {
            if(this.userdata.stringval12 == 12){
              this.userdata.stringval2 = ( this.userdata.stringval2 * 6 ) / 1.30;
            }else{
              this.userdata.stringval2 = (this.userdata.stringval2 * this.userdata.stringval12)
            }
          }
        }
        // OPS-7166 ends

          //OPS-24553
          if(this.isInHouseApplNo == true){
            this.mandateCal = 1.25;
          }else{
            this.mandateCal = 1.30;
          }
  
        // debugger;
        // check agent code for inhouse buyjourney
        if (this.userdata.stringval5 == 'CCSI' && this.userdata.stringval16 != 'NRI') {
          // alert("CCSI facility is not available. Request to you please select another renewal preferred mode.");
          if ((this.userdata.stringval2 * this.mandateCal) > 15000 && this.userdata.stringval15 != 'GBOWEB') {
            alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.");
            const newWindow = window.open('', '_self');
            if (newWindow) {
              newWindow.close();
            }
          } else {
            //this.setCCSIData();
            this.proceedwithCCSI();
          }
        }
        else if (this.userdata.stringval5 == 'CCSI' && this.userdata.stringval16 == 'NRI') {
          this.showCCSINRI = true;
          if ((this.userdata.stringval2 * this.mandateCal) > 15000 && this.userdata.stringval15 != 'GBOWEB') {
            this.showCCSI = false;
          } else {
            this.showCCSI = true;
          }
        }
        else if (this.userdata.stringval5 == 'EMAND' || this.userdata.stringval5 == 'emand') {
          //this.setEmandateData();
          this.proceedwithEMAND();
        } else if (this.userdata.stringval5 == 'NACH' || this.userdata.stringval5 == 'nach') {
          let totalAmount = (this.userdata.stringval2 * this.mandateCal);
          if (totalAmount > 10000000) {
            alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.");
            const newWindow = window.open('', '_self');
            if (newWindow) {
              newWindow.close();
            }
          } else {
            //this.setEnachData();
          let url = Constant.channelDetails(this.newAgentCode);
            this.service.getService(url, this.mandateTokenValue).subscribe((response: any) => {
              this.channel = response.channel
              this.subChannel = response.subChannel
              this.proceedwithNACh();
            }, (error) => {
              console.log(error);
            });
          }
        }

        else if (this.userdata.stringval5 == 'UPI_M' || this.userdata.stringval5 == 'upi_m') {

         //  alert("Due to technical issues, UPI Mandate service is currently unavailable.")
           //OPS-25566_UPI_Deactivate
          
          //AG-2773 Start
          let url = Constant.validateUPIAgent;
          let reqObj =
          {
            agentCode: this.userdata.stringval14,
            sysType: "UPI_CONFIG"
          }
          this.spinner.show();
          this.service.PostService(url, reqObj).subscribe((response:any) => {
            // debugger
            if (response.isAuthenticated === 'Y') {
              if(this.userdata.stringval15 == 'GBOWEB'){
                if ((this.userdata.stringval2 * this.mandateCal) > 100000) {
                  alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.");
                  const newWindow = window.open('', '_self');
                  if (newWindow) {
                    newWindow.close();
                  }
                } else {
                  //this.sendUPIDataNewCust();
                  this.proceedwithUpi();
                }
              }else{
              if ((this.userdata.stringval2 * this.mandateCal) > 15000) {
                alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.");
                const newWindow = window.open('', '_self');
                if (newWindow) {
                  newWindow.close();
                }
              } else {
                //this.sendUPIDataNewCust();
                this.proceedwithUpi();
              }
            }
           
            } else {
              if ((this.userdata.stringval2 * this.mandateCal) > 15000) {
                alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.");
                const newWindow = window.open('', '_self');
                if (newWindow) {
                  newWindow.close();
                }
              } else {
                if (this.userdata.stringval17 == 'PSF') {
                  //this.sendUPIDataNewCust();
                  this.proceedwithUpi();
                } else {
                  alert("UPI facility is not available.");
                }
              }
            }
          })
            
           //OPS-25566_UPI_Deactivate
        }
        else if (this.userdata.stringval5 == 'CA') {
          alert("You have opted module 'CA'. you can't proceed further");
          const newWindow = window.open('', '_self');
                        if (newWindow) {
                          newWindow.close();
                        }
        } else {
          alert("You have opted wrong module. you can't proceed further");
        }
      }
      else {
        alert("No Data Found");
        this.toster.error("No Data Found");
      }
    }
    else {
      alert(response.p_message);
      const newWindow = window.open('', '_self');
                        if (newWindow) {
                          newWindow.close();
                        }
    }
    setTimeout(() => {
      /** spinner ends after 3 seconds */
      this.spinner.hide();
    }, 3000);


  })
}


proceedwithUpi() {
  if (this.enableForUPIVendor === 'PAYGLOCAL') {
    this.submitUPIPgcl()
  } else if (this.enableForUPIVendor == 'RAZORPAY') {
    this.payWithRozarPayforUPI();
  }else {
    this.sendUPIDataNewCust();
  }
}

proceedwithNACh() {
  if (this.enableForNACHVendor === 'PAYGLOCAL') {
    this.submitNACHpgcl()
  } else {
    this.setEnachData();
  }
}

proceedwithEMAND() {
  if (this.enableForNACHVendor === 'PAYGLOCAL') {
    this.submitNACHpgcl()
  } else {
    this.setEmandateData();
  }
}
proceedwithCCSI() {
  if (this.enableForCCSIVendor === 'PAYGLOCAL') {
    this.submitCCSIpgcl()
  } else {
    this.setCCSIData();
  }
}



// loadJs() {

//   var acc = document.getElementsByClassName("accordion");
//   var i;

//   for (i = 0; i < acc.length; i++) {
//     acc[i].addEventListener("click", function () {
//       this.classList.toggle("active");
//       var panel = this.nextElementSibling;
//       if (panel.style.maxHeight) {
//         panel.style.maxHeight = null;
//       } else {
//         panel.style.maxHeight = panel.scrollHeight + "px";
//       }
//     });
//   }
// }
setEnachData()   // ENACH FOR NEW CUSTOMER
{
  var totalAmount:any;
  // if (this.userdata.stringval2) {
  //   totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
  //   // if (totalAmount > 1000000) {   // mandate value or calculated value
  //   //       totalAmount = 1000000;  // calculated value i.e mandate value will be 10 lac
  //   // } 
  // } else {
  //   totalAmount = this.userdata.stringval2;
  // }
  if (this.userdata.stringval2) {
    totalAmount = (this.userdata.stringval2 * this.mandateCal);
  }

  var policyHolderName = this.blockAcDtls ? this.userdata.stringval1 : "";
  (<HTMLInputElement>document.getElementById("policyHolderNameenach")).value = policyHolderName;

  (<HTMLInputElement>document.getElementById("totalAmountenach")).value = parseFloat(totalAmount).toFixed(2);

  (<HTMLInputElement>document.getElementById("consumerIdenach")).value = this.policyno;

  var consumerMobileNo = this.userdata.stringval3;
  (<HTMLInputElement>document.getElementById("consumerMobileNoenach")).value = consumerMobileNo;

  var consumerEmailId = this.userdata.stringval4;
  (<HTMLInputElement>document.getElementById("consumerEmailIdenach")).value = consumerEmailId;

  var debitStartDate = this.userdata.stringval6;
  (<HTMLInputElement>document.getElementById("debitStartDateenach")).value = debitStartDate;

  var debitEndDate = this.userdata.stringval7;
  (<HTMLInputElement>document.getElementById("debitEndDateenach")).value = debitEndDate;

  var maxAmount = '100';
  (<HTMLInputElement>document.getElementById("maxAmountenach")).value = maxAmount;

  var amountType = "M";
  (<HTMLInputElement>document.getElementById("amountTypeenach")).value = amountType;

  var frequency = "ADHO";
  (<HTMLInputElement>document.getElementById("frequencyenach")).value = frequency;

  var moduleName = "INSTAB|OPEN_LINK_NEW";
  (<HTMLInputElement>document.getElementById("moduleNameenach")).value = moduleName;

  var accountNo = this.blockAcDtls ? this.userdata.stringval9 : "";
  (<HTMLInputElement>document.getElementById("accountNoe")).value = accountNo;

  var ifscCode = this.blockAcDtls ? this.userdata.stringval11 : "";
  (<HTMLInputElement>document.getElementById("ifscCodee")).value = ifscCode;

  // console.log("totalAmount is",totalAmount)

  setTimeout(() => {
    this.enachform.nativeElement.click();
  }, 1000);
}

setEmandateData() {   //Emandate for NEW Customer

  // console.log("response.p_pymnt_list", this.userdata);

  var policyHolderName = this.blockAcDtls ? this.userdata.stringval1 : "";
  (<HTMLInputElement>document.getElementById("policyHolderNameexeman")).value = policyHolderName;

  var totalAmount = '5';
  (<HTMLInputElement>document.getElementById("totalAmountexeman")).value = totalAmount;

  (<HTMLInputElement>document.getElementById("consumerIdexeman")).value = this.policyno;

  var consumerMobileNo = this.userdata.stringval3;
  (<HTMLInputElement>document.getElementById("consumerMobileNoexeman")).value = consumerMobileNo;

  var consumerEmailId = this.userdata.stringval4;
  (<HTMLInputElement>document.getElementById("consumerEmailIdexeman")).value = consumerEmailId;

  var debitStartDate = this.userdata.stringval6;
  (<HTMLInputElement>document.getElementById("debitStartDateexeman")).value = debitStartDate;

  var debitEndDate = this.userdata.stringval7;
  (<HTMLInputElement>document.getElementById("debitEndDateexeman")).value = debitEndDate;

  var maxAmount:any;
  maxAmount = this.userdata.stringval2 * this.mandateCal;
  //maxAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
  // var maxAmount = this.userdata.stringval8;
  (<HTMLInputElement>document.getElementById("maxAmountexeman")).value = parseFloat(maxAmount).toFixed(2);

  var amountType = "M";
  (<HTMLInputElement>document.getElementById("amountTypeexeman")).value = amountType;

  var frequency = "ADHO";
  (<HTMLInputElement>document.getElementById("frequencyexeman")).value = frequency;

  var renewalID = "";
  (<HTMLInputElement>document.getElementById("renewalIDexeman")).value = renewalID;

  var moduleName = "OPEN_LINK_NEW";
  (<HTMLInputElement>document.getElementById("moduleIdexeman")).value = moduleName;

  var payableAmount = '0';
  (<HTMLInputElement>document.getElementById("payableAmountexeman")).value = payableAmount;

  var accountNo = this.blockAcDtls ? this.userdata.stringval9 : "";
  (<HTMLInputElement>document.getElementById("accountNo")).value = accountNo;

  var ifscCode = this.blockAcDtls ? this.userdata.stringval11 : "";
  (<HTMLInputElement>document.getElementById("ifscCode")).value = ifscCode;

  setTimeout(() => {
    this.myDiv.nativeElement.click();
  }, 1000);
}


// setCCSIData()  // CCSI for Existing Customer
// {

//     // console.log("user data existing ",this.userdata)
//     var policyHolderName =  this.userdata.stringval1;
//     (<HTMLInputElement>document.getElementById("policyHolderccsiexi")).value = policyHolderName;

//     var totalAmount = this.userdata.stringval2;
//     (<HTMLInputElement>document.getElementById("totalAmountccsiexi")).value = parseFloat(totalAmount).toFixed(2);

//     (<HTMLInputElement>document.getElementById("consumerIdccsiexi")).value = this.policyno;

//     var consumerMobileNo = this.userdata.stringval3;
//     (<HTMLInputElement>document.getElementById("consumerMobileNoccsiexi")).value = consumerMobileNo;

//     var consumerEmailId = this.userdata.stringval4;
//     (<HTMLInputElement>document.getElementById("consumerEmailIdccsiexi")).value = consumerEmailId;

//     var debitStartDate = this.userdata.stringval6;
//     (<HTMLInputElement>document.getElementById("debitStartDateccsiexi")).value = debitStartDate;

//     var debitEndDate = this.userdata.stringval7;
//     (<HTMLInputElement>document.getElementById("debitEndDateccsiexi")).value = debitEndDate;

//     (<HTMLInputElement>document.getElementById("return_urlccsiexi")).value = this.ccsiReturnUrl;

//   setTimeout(() => {
//     this.ccsiform.nativeElement.click();
//   }, 1000);
// }

sendUPIDataNewCust() {    // UPI Mandate for new customer
  //debugger
  var maxAmount;
  var calMaxAmt:any;
  var moduleName = this.userdata.stringval15;
  calMaxAmt = (this.userdata.stringval2 * this.mandateCal);
  // if (moduleName == 'GBOWEB') {
  //   calMaxAmt = (this.userdata.stringval2 * 1.25);  //call no :MRKT-2104
  // } else {
  //   calMaxAmt = (this.userdata.stringval2 * 1.1);
  // }
  //console.log(this.userdata);

  // if ((this.userdata.stringval2 <= 5000) && (this.userdata.stringval8 > 5000)) {   // calulated value
  //calMaxAmt = (this.userdata.stringval2 * 1.1);
  maxAmount = calMaxAmt.toFixed(2)


  if (maxAmount > 15000) {
    alert("Mandate amount exceeds maximum amount limit.");
    return;
  } else {
    maxAmount = maxAmount;
    var policyHolderName = this.blockAcDtls ? this.userdata.stringval1 : "";
    (<HTMLInputElement>document.getElementById("policyHolderNameu")).value = policyHolderName;

    var totalAmount = '0';
    (<HTMLInputElement>document.getElementById("totalAmountu")).value = totalAmount;

    var consumerId = this.policyno;
    (<HTMLInputElement>document.getElementById("consumerIdu")).value = consumerId;

    var consumerMobileNo = this.userdata.stringval3;
    (<HTMLInputElement>document.getElementById("consumerMobileNou")).value = consumerMobileNo;

    var consumerEmailId = this.userdata.stringval4;
    (<HTMLInputElement>document.getElementById("consumerEmailIdu")).value = consumerEmailId;

    var debitStartDate = this.userdata.stringval6;
    (<HTMLInputElement>document.getElementById("debitStartDateu")).value = debitStartDate;

    var debitEndDate = this.userdata.stringval7;
    (<HTMLInputElement>document.getElementById("debitEndDateu")).value = debitEndDate;

    // var maxAmount = this.userdata.stringval8;
    (<HTMLInputElement>document.getElementById("maxAmountu")).value = maxAmount;

    var amountType = "M";
    (<HTMLInputElement>document.getElementById("amountTypeu")).value = 'M'

    var frequency = "ADHO";
    (<HTMLInputElement>document.getElementById("frequencyu")).value = frequency;

    var renewalID = "OPEN_LINK_NEW";
    (<HTMLInputElement>document.getElementById("renewalIDu")).value = renewalID;

    var payableAmount = '0';
    (<HTMLInputElement>document.getElementById("payableAmountu")).value = payableAmount;

    var accountNo = this.blockAcDtls ? this.userdata.stringval9 : "";
    (<HTMLInputElement>document.getElementById("accountNo")).value = accountNo;

    var ifscCode = this.blockAcDtls ? this.userdata.stringval11 : "";
    (<HTMLInputElement>document.getElementById("ifscCode")).value = ifscCode;

    setTimeout(() => {
      this.upiform.nativeElement.click();
    }, 1000);

  }


}

setCCSIData()  // CCSI for Existing Customer
{

  // console.log("user data existing ",this.userdata)
  var policyHolderName = this.userdata.stringval1;
  (<HTMLInputElement>document.getElementById("policyHolderccsiexi")).value = policyHolderName;

  var totalAmount:any;
  // if (this.userdata.stringval2) {
  //   totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
  // } else {
  //   totalAmount = this.userdata.stringval2;
  // }
  if (this.userdata.stringval2) {
    if(this.channel == 'PSF'){
      if(this.userdata.stringval12 == 12){
        totalAmount = this.userdata.stringval2 * 6;
      }
      else{
        totalAmount = this.userdata.stringval2 * this.mandateCal * this.userdata.stringval12;
      }
    }else{
         totalAmount = this.userdata.stringval2 * this.mandateCal;
    }
  }


  (<HTMLInputElement>document.getElementById("totalAmountccsiexi")).value = parseFloat(totalAmount).toFixed(0);

  (<HTMLInputElement>document.getElementById("consumerIdccsiexi")).value = this.policyno;

  var consumerMobileNo = this.userdata.stringval3;
  (<HTMLInputElement>document.getElementById("consumerMobileNoccsiexi")).value = consumerMobileNo;

  var consumerEmailId = this.userdata.stringval4;
  (<HTMLInputElement>document.getElementById("consumerEmailIdccsiexi")).value = consumerEmailId;

  var debitStartDate = this.userdata.stringval6;
  (<HTMLInputElement>document.getElementById("debitStartDateccsiexi")).value = debitStartDate;

  var debitEndDate = this.userdata.stringval7;
  (<HTMLInputElement>document.getElementById("debitEndDateccsiexi")).value = debitEndDate;

  (<HTMLInputElement>document.getElementById("return_urlccsiexi")).value = this.ccsiReturnUrl;

  setTimeout(() => {
    this.ccsiform.nativeElement.click();
  }, 1000);
}


//implemet international ccsi start

openCCSINRI() {
  this.spinner.show();
  let generateURL = Constant.NRIccsi;
  var options

  const date1 = this.userdata.stringval6;
  const prt:any = moment(date1, 'DD-MM-YYYY');
  const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
  const date2 = this.userdata.stringval7;
  const prt1:any = moment(date2, 'DD-MM-YYYY');
  var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');



  // Calculate the year difference
  const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();
  if (yearDiff > 40) {
    const maxAllowedDate:any = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
    formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
  }

  var totalAmount:any;
  // if (this.userdata.stringval2) {
  //   totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
  // } else {
  //   totalAmount = this.userdata.stringval2;
  // }
 if (this.userdata.stringval2) {
       totalAmount = this.userdata.stringval2 * this.mandateCal;
  }
  
  options = {
    "merchantTxnId": this.policyno,
    "paymentType": "PGCLINTCCSI",
      "surchargeTxn":"true",
    "siAllowedPaymentMethods": ["CARD"],
    "allowedPaymentMethods": [
      {
        "paymentMethod": "CARD"
      }
    ],
    "paymentData": {
      "totalAmount": 1,
      "txnCurrency": "INR"
    },
    "riskData": {
      "customerData": {
        "customerCategory": "FC"
      }
    },
    "standingInstruction": {
      "data": {
        "maxAmount": parseFloat(totalAmount).toFixed(),
        "numberOfPayments": "N",
        "frequency": "ONDEMAND",
        "type": "VARIABLE",
        "startDate": formattedDate1,
        "endDate": formattedDate2,
        "mode": "REGISTER"
      }
    },
    "merchantCallbackURL": Constant.NRIccsiCallbackURL,
    "moduleName": "OPEN_LINK_NEW",
      "callbackURL": this.callbackURL,
    "policyHolderName": this.userdata.stringval1,
    "dualMandateFlag": this.dualMandateFlag,
    "dualMandateType": this.dualMandateType
  }


  this.service.PostService(generateURL, options).subscribe((response: any) => {

    if (response.status == 'INPROGRESS') {
      this.ccsiPayglocal = response.data.redirectUrl;
      // window.open(this.ccsiPayglocal.toString(), '_blank');
      // this.spinner.hide();
      window.location.href = this.ccsiPayglocal.toString();
    } else {
      this.toster.error("ERROR :: " + response.status);
      this.spinner.hide();
    }
  })
}

openDomesticCCSI() {
  //this.setCCSIData();
  this.proceedwithCCSI()
}




//payglocal implemenation starts

submitNACHpgcl() {
  this.spinner.show();
  let generateURL = Constant.NRIccsi;
  var options

  const date1 = this.userdata.stringval6;
  const prt = moment(date1, 'DD-MM-YYYY').toDate();
  // const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
  const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
  const date2 = this.userdata.stringval7;
  const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
  var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');


  // Calculate the year difference
  const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

  if (yearDiff > 40) {
    const maxAllowedDate:any = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
    formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
  }

  var totalAmount:any;
  // if (this.userdata.stringval2) {
  //   totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
  // } else {
  //   totalAmount = this.userdata.stringval2;
  // }

  if (this.userdata.stringval2) {
    totalAmount = this.userdata.stringval2 * this.mandateCal;
  }


  options = {
    "merchantTxnId": this.policyno,
    "paymentType": "PGCLNACH",
    "allowedPaymentMethods": [
      {
        "paymentMethod": "DIGITAL_BANK_MANDATE"
      }
    ],
    "siAllowedPaymentMethods": ["DIGITAL_BANK_MANDATE"],
    "paymentData": {
      "totalAmount": "1",
      "txnCurrency": "INR"
    },
    "standingInstruction": {
      "data": {
        "maxAmount": parseFloat(totalAmount).toFixed(),
        "numberOfPayments": "N",
        "frequency": "ONDEMAND",
        "type": "VARIABLE",
        "startDate": formattedDate1,
        "endDate": formattedDate2,
        "mode": "REGISTER"
      }
    },
    "moduleName": "INSTAB|OPEN_LINK_NEW",
    "product": {
      "productUserName": this.userdata.stringval1
    },
    "merchantCallbackURL": Constant.pgclNACHCallbackURL,
    "policyHolderName": this.userdata.stringval1,
    "callbackURL": this.callbackURL,
    "dualMandateFlag": this.dualMandateFlag,
    "dualMandateType": this.dualMandateType
  }


  this.service.PostService(generateURL, options).subscribe((response: any) => {
    if (response.status == 'INPROGRESS' && response.p_next_page != 'error') {
      this.ccsiPayglocal = response.data.redirectUrl;
      // window.open(this.ccsiPayglocal.toString(), '_blank');
      // this.spinner.hide();
      window.location.href = this.ccsiPayglocal.toString();
    } else if (response.status == 'INPROGRESS' && response.p_next_page == 'error') {
      this.toster.error("ERROR :" + response.p_error_msg);
      this.spinner.hide();
    }
    else {
      this.toster.error("ERROR :: " + response.status);
      this.spinner.hide();
    }
  })

}

submitUPIPgcl() {
  this.spinner.show();
  let generateURL = Constant.NRIccsi;
  var options


  const date1 = this.userdata.stringval6;
  const prt = moment(date1, 'DD-MM-YYYY').toDate();
  // const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
  const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
  const date2 = this.userdata.stringval7;
  const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
  var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

  // Calculate the year difference
  const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

  if (yearDiff > 40) {
    const maxAllowedDate:any = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
    formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
  }



  // var maxAmount;
  // var calMaxAmt;
  // calMaxAmt = (this.userdata.stringval2 * 1.1);
  // maxAmount =  parseFloat(calMaxAmt).toFixed(),
  var maxAmount;
  var calMaxAmt:any;
  // var moduleName = this.userdata.stringval15;
  // if (moduleName == 'GBOWEB') {
  //   calMaxAmt = (this.userdata.stringval2 * 1.25);  //call no :MRKT-2104
  // } else {
  //   calMaxAmt = (this.userdata.stringval2 * 1.1);
  // }
  calMaxAmt = (this.userdata.stringval2 * this.mandateCal);
  maxAmount = calMaxAmt.toFixed(2)

  options = {
    "merchantTxnId": this.policyno,
    "paymentType": "PGCLUPI",
    "siAllowedPaymentMethods": ["UPI_INTENT", "UPI_COLLECT"],
    "allowedPaymentMethods": [
      {
        "paymentMethod": "UPI_INTENT"
      },
      {
        "paymentMethod": "UPI_COLLECT"
      }
    ],
    "paymentData": {
      "totalAmount": 1,
      "txnCurrency": "INR"
    },

    "standingInstruction": {
      "data": {
        "maxAmount": parseFloat(maxAmount).toFixed(),
        "numberOfPayments": "N",
        "frequency": "ONDEMAND",
        "type": "VARIABLE",
        "startDate": formattedDate1,
        "endDate": formattedDate2,
        "mode": "REGISTER"
      }
    },
    "merchantCallbackURL": Constant.pgclUPICallbackURL,
    "moduleName": "OPEN_LINK_NEW",
      "callbackURL": this.callbackURL,
    "policyHolderName": this.userdata.stringval1,
    "dualMandateFlag": this.dualMandateFlag,
    "dualMandateType": this.dualMandateType
  }

  if (maxAmount > 15000) {
    this.spinner.hide();
    alert("Mandate amount exceeds maximum amount limit.");
    return;
  } else {
    this.service.PostService(generateURL, options).subscribe((response: any) => {
      if (response.status == 'INPROGRESS') {
        this.ccsiPayglocal = response.data.redirectUrl;
        // window.open(this.ccsiPayglocal.toString(), '_blank');
        // this.spinner.hide();
        window.location.href = this.ccsiPayglocal.toString();
      } else {
        this.toster.error("ERROR :: " + response.status);
        this.spinner.hide();
      }
    })
  }

}

submitCCSIpgcl() {
  this.spinner.show();
  let generateURL = Constant.NRIccsi;
  var options
  const date1 = this.userdata.stringval6;
  const prt:any = moment(date1, 'DD-MM-YYYY');
  //const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
  const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
  const date2 = this.userdata.stringval7;
  const prt1:any = moment(date2, 'DD-MM-YYYY');
  var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');


  // Calculate the year difference
  const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

  if (yearDiff > 40) {
    const maxAllowedDate:any = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
    formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
  }

  var totalAmount:any;
  // if (this.userdata.stringval2) {
  //   totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
  // } else {
  //   totalAmount = this.userdata.stringval2;
  // }

  if (this.userdata.stringval2) {
    // debugger
    if(this.channel == 'PSF'){
      if(this.userdata.stringval12 == 12){
        totalAmount = this.userdata.stringval2 * 6;
      }
      else{
        totalAmount = this.userdata.stringval2 * this.mandateCal * this.userdata.stringval12;
      }
    }else{
         totalAmount = this.userdata.stringval2 * this.mandateCal;
    }
   
  }

  options = {
    "merchantTxnId": this.policyno,
    "paymentType": "PGCLDOMESTICCCSI",
    "surchargeTxn":"true",
    "siAllowedPaymentMethods": ["CARD"],
    "allowedPaymentMethods": [
      {
        "paymentMethod": "CARD"
      }
    ],
    "paymentData": {
      "totalAmount": 1,
      "txnCurrency": "INR"
    },
    "standingInstruction": {
      "data": {
        "maxAmount": parseFloat(totalAmount).toFixed(),
        "numberOfPayments": "N",
        "frequency": "ONDEMAND",
        "type": "VARIABLE",
        "startDate": formattedDate1,
        "endDate": formattedDate2,
        "mode": "REGISTER"
      }
    },
    "merchantCallbackURL": Constant.pgclCCSICallbackURL,
    "moduleName": "OPEN_LINK_NEW",
      "callbackURL": this.callbackURL,
    "policyHolderName": this.userdata.stringval1,
    "dualMandateFlag": this.dualMandateFlag,
    "dualMandateType": this.dualMandateType
  }


  this.service.PostService(generateURL, options).subscribe((response: any) => {
    if (response.status == 'INPROGRESS') {
      this.ccsiPayglocal = response.data.redirectUrl;
      // window.open(this.ccsiPayglocal.toString(), '_blank');
      // this.spinner.hide();
      window.location.href = this.ccsiPayglocal.toString();
    } else {
      this.toster.error("ERROR :: " + response.status);
      this.spinner.hide();
    }
  })
}

//payglocal implemenation ends


payWithRozarPayforUPI() {
  let data;
  let merchantID = Constant.RAZORPAY_KEY;

  var maxAmount;
  var calMaxAmt:any;
 // calMaxAmt = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
 calMaxAmt = (this.userdata.stringval2 * this.mandateCal);
 maxAmount = parseFloat(calMaxAmt).toFixed(),

    data = {
      'policyHolderName': '',
      'totalAmount': 0,
      'merchantId': merchantID,
      'consumerId': this.policyno,
      'consumerMobileNo': this.userdata.stringval3,
      'consumerEmailId': this.userdata.stringval4,
      'debitStartDate': this.userdata.stringval6,
      'debitEndDate': this.userdata.stringval7,
      'maxAmount': maxAmount,
      'amountType': 'M',
      'frequency': 'ADHO',
      'moduleName': "OPEN_LINK_NEW",
      // 'moduleName': "OPEN_LINK_NEW",
      'renewalID': "OPEN_LINK_NEW",
      'payableAmount': 0,
      'takeAccountNo': this.userdata.stringval9,
      'takeIFSCCode': this.userdata.stringval11,
      'prefDate': '',
      'prefType': '',
      'authType': '',
      "paymode": "upi"
    }


  let url = Constant.createCustomerUPI;
  let reqObj = data;
  this.spinner.show();
  //console.log("Request1"+reqObj)

  this.service.PostService(url, reqObj).subscribe((response: any) => {
    console.log(response);
    if (response && response.oid && response.custRes.id) {
      this.spinner.hide();
      this.callRozarPayforUPI(response.oid, response.custRes.id);
    }
    else {
      this.spinner.hide();
      alert(response.p_message);
    }
  })
}

callRozarPayforUPI(orderID: any, custID: any) {
  let merchantID = Constant.RAZORPAY_KEY;
  var options = {
    "key": merchantID,
    "order_id": orderID,
    "customer_id": custID,
    "recurring": "1",
    "name": "Bajaj Life Insurance Limited",
    "image": "./assets/img/bajaj-logo.png",
    "handler": (response: any) => {
      console.log(response);
      if (response) {
        localStorage.setItem("s2sResponse", JSON.stringify(response));
        this.ngZone.run(() => this.router.navigate(['/rpThankYou']))
      }
    },
    "notes": {
      "note_key 1": "",
      "note_key 2": ""
    },
    "retry": {
      "enabled": false
    },
    "hidden": {
      "email": true,
      "contact": true
    },
    "theme": {
      "color": "#3977b7"
    }
  };
  var rzp1 = new this.service.nativeWindow.Razorpay(options);
  rzp1.open();
  rzp1.on('payment.failed', (response: any) => {
    localStorage.setItem("razorpayError", JSON.stringify(response));
    this.ngZone.run(() => this.router.navigate(['/rpFailed']))
  });
}


}
